import { RootState } from "@/store/store";
import {
  SolutionArchitectRecommendationRequest,
  SolutionArchitectRequest,
} from "@/services/cloudchipr.api";
import { infrastructureArchitectureRequestDataSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureRequestDataSelector";
import { allAccountsSelectOptionsSelector } from "@/store/accounts/selectors/all-providers/allAccountsSelectOptionsSelector";

export const infrastructureArchitectureRequestsPayloadSelector = (
  state: RootState,
):
  | SolutionArchitectRequest
  | SolutionArchitectRecommendationRequest
  | undefined => {
  const {
    selectedAccountId,
    selectedRegion,
    selectedServices,
    selectedArchitectureId,
  } = infrastructureArchitectureRequestDataSelector(state) ?? {};
  const accounts = allAccountsSelectOptionsSelector(state);
  const providerAccountId = accounts.find(
    (option) => option.value === selectedAccountId,
  )?.providerAccountId;

  if (!providerAccountId || !selectedRegion) {
    return;
  }

  return {
    provider_account_id: providerAccountId,
    region: selectedRegion,
    resource_types: selectedServices,
    architecture_id: selectedArchitectureId,
  };
};
